// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__phvG+","modal":"styles_modal__kUd24","header":"styles_header__EyeN-","title":"styles_title__6oBvn","description":"styles_description__95Lcg"};